var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"subtitle-2 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"body-2 font-weight-thin"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }